import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import Reveal from '@/components/base/Reveal';
import { topics } from '@/mocks/topics';

const legend = [
  { key: 'support', label: '支持方', color: 'bg-primary-500' },
  { key: 'neutral', label: '中立', color: 'bg-secondary-400' },
  { key: 'oppose', label: '反对方', color: 'bg-accent-500' },
];

export default function OpinionSection() {
  const list = topics.slice(0, 4);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20" id="opinion">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            eyebrow="Public Opinion"
            title="舆论风向观察"
            desc="把评论区里的声音归类统计，用一根横条还原讨论的大致倾向。比例会随讨论推进而变化。"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <Reveal className="lg:col-span-1">
            <aside className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6">
              <h3 className="text-base font-semibold text-foreground-950">怎么看这张风向图</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                横条中的三段分别代表支持、中立与反对的占比。数值来自公开讨论的抽样统计，用来观察讨论的集中程度，不构成对事件任何一方的判断。
              </p>
              <ul className="mt-5 space-y-3">
                {legend.map((l) => (
                  <li key={l.key} className="flex items-center gap-3 text-sm text-foreground-700">
                    <span className={`h-3 w-3 rounded-sm ${l.color}`} />
                    {l.label}
                  </li>
                ))}
              </ul>
              <div className="mt-auto pt-6">
                <Link
                  to="/topics"
                  className="flex w-full cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  查看全部风向
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </aside>
          </Reveal>

          <div className="grid grid-cols-1 gap-4 lg:col-span-2">
            {list.map((topic, i) => (
              <Reveal key={topic.id} delay={i * 50}>
                <Link
                  to={`/topics/${topic.id}`}
                  className="group block cursor-pointer rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
                >
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="line-clamp-1 flex-1 text-sm font-medium text-foreground-900 group-hover:text-primary-600 md:text-base">
                      {topic.title}
                    </h3>
                    <span className="shrink-0 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                      {topic.category}
                    </span>
                  </div>

                  <div className="mt-4 flex h-3 w-full overflow-hidden rounded-full bg-background-200">
                    <div className="bg-primary-500" style={{ width: `${topic.stats.support}%` }} />
                    <div className="bg-secondary-400" style={{ width: `${topic.stats.neutral}%` }} />
                    <div className="bg-accent-500" style={{ width: `${topic.stats.oppose}%` }} />
                  </div>

                  <div className="mt-2 flex flex-wrap items-center gap-x-5 gap-y-1 text-xs text-foreground-500">
                    <span>支持 {topic.stats.support}%</span>
                    <span>中立 {topic.stats.neutral}%</span>
                    <span>反对 {topic.stats.oppose}%</span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}